import { combineReducers } from 'redux';
import communities from './communities';
import map from './map';
import filters from './filters';
import markerData from './markerData';
import regionData from './regionData';
import mobileLocFilters from './mobileLocationFilters';
import mortgageCalc from './mortgageCalc';

const root = combineReducers({
  communities,
  map,
	filters,
  markerData,
  regionData,
  mobileLocFilters,
  mortgageCalc
});

export default root;
